// What the client does with one /groups/overview answer.
//
// Pulled out of App.js so the rule below can be tested against the REAL code
// rather than a copy of it — the copy passes whatever you write, which is worth
// nothing.
//
// The rule: null means the server could not build that part, [] means there is
// nothing. Only an actual array is applied. The three requests this replaces
// were independently fault-tolerant — the client used whichever answered — so
// one part failing must leave the others, and the state already on screen,
// untouched. Testing truthiness instead of Array.isArray would break the other
// direction: someone who leaves their last group would never see the list empty.
export function applyOverview(data, set) {
  if (!data || !set) return 0;
  let applied = 0;
  for (const key of ["groups", "requests", "pending", "invitations", "other_markets"]) {
    if (Array.isArray(data[key]) && typeof set[key] === "function") {
      set[key](data[key]);
      applied += 1;
    }
  }
  return applied;
}
